//
//

import { uid } from "quasar";
import AQButton from "@/components/Generics/AQButton/AQButton.vue";
import EditCatModal from "../editCatModal/editCatModal.vue";

export default {
    name: "NoCatPage",
    components: { EditCatModal, AQButton },
    props: {
        readonly: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            pageName: "NoCatPage",
            showDlg: false
        };
    },
    computed: {
        canWriteCD() {
            // eslint-disable-next-line max-len
            return this.$route.params.permissions && this.$route.params.permissions.hasOwnProperty("permissionsData") && this.$route.params.permissions.permissionsData.hasOwnProperty("CD") && this.$route.params.permissions.permissionsData.CD === "w";
        },
        canWriteCS() {
            // eslint-disable-next-line max-len
            return this.$route.params.permissions && this.$route.params.permissions.hasOwnProperty("permissionsData") && this.$route.params.permissions.permissionsData.hasOwnProperty("CS") && this.$route.params.permissions.permissionsData.CS === "w";
        },
        isOwner() {
            return this.$route.params.permissions && this.$route.params.permissions.hasOwnProperty("owner") ? this.$route.params.permissions.owner : null;
        }
    },
    methods: {
        addNew() {
            this.showDlg = true;
            const columns = [
                {
                    type: "String",
                    name: "code",
                    delete: false,
                    id: uid(),
                    default: true
                },
                {
                    type: "String",
                    name: "name",
                    delete: false,
                    id: uid(),
                    default: true
                }
            ];
            this.$store.commit("catalogs/setTemporaryColumnsCache", columns);
            this.showEditModal = true;
            this.$store.commit("catalogs/setInEditCatalogColumns", columns);
        },
        modalClosed() {
            this.showDlg = false;
        }
    }
};
